import { render, staticRenderFns } from "./RedirectEffect.vue?vue&type=template&id=348b5546&"
import script from "./RedirectEffect.vue?vue&type=script&lang=ts&"
export * from "./RedirectEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports